(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acid-wash-trio-builder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aw').forEach((root)=>{const sizes=[...root.querySelectorAll('.aw-size')],colours=[...root.querySelectorAll('.aw-colour')],previews=[...root.querySelectorAll('.aw__picked-card')],add=root.querySelector('.aw__add'),counter=root.querySelector('.aw__counter'),error=root.querySelector('.aw__error'),sizeGuide=root.querySelector('.aw__size-guide-dialog'),sizeGuideOpen=[...root.querySelectorAll('.aw__size-guide-open')],sizeGuideClose=root.querySelector('.aw__size-guide-close');let selected=[];let active=sizes.find(b=>b.classList.contains('is-on'));let size=active?.dataset.size||'',variant=active?.dataset.variant||'';const render=()=>{colours.forEach(b=>{const on=selected.some(i=>i.colour===b.dataset.colour);b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',String(on));b.disabled=selected.length===3&&!on});previews.forEach((card,index)=>{const item=selected[index];card.classList.toggle('is-empty',!item);card.querySelector('.aw__crop').style.backgroundImage=item?`url("${item.image}")`:'';card.querySelector('strong').textContent=item?`${item.colour} · ${size}`:'Pick a colour'});counter.textContent=`${selected.length}/3`;add.disabled=selected.length!==3||!size;add.textContent=add.disabled?`Pick ${3-selected.length} colour${3-selected.length===1?'':'s'} to continue`:'Add My Pack — ₹1,799 at Checkout';error.hidden=true};const thumbs=[...root.querySelectorAll('.aw__thumb')],hero=root.querySelector('.aw__hero');let galleryIndex=Math.max(0,thumbs.findIndex(t=>t.classList.contains('is-on')));const showImage=(url)=>{const main=root.querySelector('.aw__main-image');if(!url||!main)return;main.srcset='';main.src=url;main.style.opacity='1';const index=thumbs.findIndex(t=>t.dataset.galleryImage===url);if(index>=0)galleryIndex=index;thumbs.forEach((t,i)=>{const on=i===galleryIndex;t.classList.toggle('is-on',on);t.setAttribute('aria-current',String(on))});const current=thumbs[galleryIndex];if(current){main.alt=current.querySelector('img')?.alt||main.alt;const gallery=current.parentElement;gallery.scrollTo({left:Math.max(0,current.offsetLeft-gallery.offsetLeft-(gallery.clientWidth-current.clientWidth)/2),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}};const stepImage=(direction)=>{if(!thumbs.length)return;showImage(thumbs[(galleryIndex+direction+thumbs.length)%thumbs.length].dataset.galleryImage)};thumbs.forEach(t=>t.addEventListener('click',()=>showImage(t.dataset.galleryImage)));root.querySelectorAll('[data-gallery-direction]').forEach(b=>b.addEventListener('click',()=>stepImage(Number(b.dataset.galleryDirection))));let swipe=null;if(hero){hero.addEventListener('touchstart',event=>{swipe=event.touches.length===1&&!event.target.closest('button')?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null},{passive:true});hero.addEventListener('touchend',event=>{if(!swipe||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-swipe.x,dy=event.changedTouches[0].clientY-swipe.y;swipe=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)stepImage(dx<0?1:-1)},{passive:true});hero.addEventListener('touchcancel',()=>{swipe=null},{passive:true});hero.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();stepImage(event.key==='ArrowLeft'?-1:1)}})};sizes.forEach(b=>b.addEventListener('click',()=>{sizes.forEach(i=>{i.classList.remove('is-on');i.setAttribute('aria-checked','false')});b.classList.add('is-on');b.setAttribute('aria-checked','true');size=b.dataset.size;variant=b.dataset.variant;render()}));colours.forEach(b=>b.addEventListener('click',()=>{const index=selected.findIndex(i=>i.colour===b.dataset.colour);if(index>=0)selected.splice(index,1);else if(selected.length<3){selected.push({colour:b.dataset.colour,image:b.dataset.image});showImage(b.dataset.image)}render()}));if(sizeGuide&&sizeGuideOpen.length&&sizeGuideClose){sizeGuideOpen.forEach(button=>button.addEventListener('click',()=>sizeGuide.showModal()));sizeGuideClose.addEventListener('click',()=>sizeGuide.close());sizeGuide.addEventListener('click',event=>{if(event.target===sizeGuide)sizeGuide.close()})}add.addEventListener('click',async()=>{if(selected.length!==3||!variant)return;add.classList.add('is-loading');add.textContent='Adding your trio…';error.hidden=true;const properties={'Pack size':size,'Tee 1':selected[0].colour,'Tee 2':selected[1].colour,'Tee 3':selected[2].colour};try{const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,properties}]})});if(!response.ok)throw new Error('We could not add this pack. Please try again.');window.location.href=`${window.Shopify.routes.root}cart`}catch(caught){error.textContent=caught.message;error.hidden=false;add.classList.remove('is-loading');render()}});render()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-travel-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hm-travel-home')) {
  customElements.define('hm-travel-home', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.tabs = [...this.querySelectorAll('[data-pack]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.heroSlides = [...this.querySelectorAll('[data-hero-slide]')];
      this.heroDots = [...this.querySelectorAll('[data-hero-dot]')];
      this.heroIndex = 0;
      this.motionPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const motionVideos = [...this.querySelectorAll('[data-hm-motion-video]')];
      const motionToggle = this.querySelector('[data-hm-motion-toggle]');
      const mobileMedia = window.matchMedia('(max-width: 749px)');
      const loadMotion = () => {
        motionVideos.forEach(video => {
          video.muted = true;
          video.poster = mobileMedia.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
          const source = mobileMedia.matches ? video.dataset.mobileSource : video.dataset.desktopSource;
          if (video.getAttribute('src') !== source) { video.src = source; video.load(); }
          if (!this.motionPaused && video.closest('[data-hero-slide]').classList.contains('is-active')) video.play().catch(() => {});
        });
      };
      if (motionToggle) motionToggle.setAttribute('aria-pressed', String(this.motionPaused));
      loadMotion();
      mobileMedia.addEventListener('change', loadMotion);
      const showHero = (index) => {
        if (!this.heroSlides.length) return;
        this.heroIndex = (index + this.heroSlides.length) % this.heroSlides.length;
        this.heroSlides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.heroIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('[data-hm-motion-video]').forEach(video => {
            if (active && !this.motionPaused) {
              video.currentTime = 0;
              video.play().catch(() => {});
            } else video.pause();
          });
        });
        this.heroDots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === this.heroIndex)));
      };
      let heroTimer;
      const startHero = () => {
        window.clearTimeout(heroTimer);
        if (!this.motionPaused && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const delay = Number(this.heroSlides[this.heroIndex]?.dataset.heroDuration) || 5000;
          heroTimer = window.setTimeout(() => { showHero(this.heroIndex + 1); startHero(); }, delay);
        }
      };
      const restartHero = () => {
        startHero();
      };
      showHero(0);
      startHero();
      this.addEventListener('mouseenter', () => window.clearTimeout(heroTimer));
      this.addEventListener('mouseleave', startHero);
      this.addEventListener('focusin', () => window.clearTimeout(heroTimer));
      this.addEventListener('focusout', startHero);
      const activate = (id) => {
        this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== id; });
        const mobilePicker = this.querySelector('[data-mobile-pack]');
        if (mobilePicker) mobilePicker.value = id;
        this.tabs.forEach(tab => {
          if (tab.dataset.pack === id) tab.setAttribute('aria-current', 'true');
          else tab.removeAttribute('aria-current');
        });
      };
      if (this.tabs.length) {
        const initialTab = this.tabs.find(tab => tab.classList.contains('hmth-tab--slow')) || this.tabs[0];
        activate(initialTab.dataset.pack);
      }
      this.addEventListener('click', event => {
        if (event.target.closest('[data-hm-motion-toggle]')) {
          this.motionPaused = !this.motionPaused;
          motionToggle.setAttribute('aria-pressed', String(this.motionPaused));
          motionVideos.forEach(video => {
            if (this.motionPaused) video.pause();
            else if (video.closest('[data-hero-slide]').classList.contains('is-active')) video.play().catch(() => {});
          });
          startHero();
          return;
        }
        const heroDot = event.target.closest('[data-hero-dot]');
        if (heroDot && this.contains(heroDot)) {
          showHero(Number(heroDot.dataset.heroDot));
          restartHero();
          return;
        }
        if (event.target.closest('[data-hero-prev]')) {
          showHero(this.heroIndex - 1);
          restartHero();
          return;
        }
        if (event.target.closest('[data-hero-next]')) {
          showHero(this.heroIndex + 1);
          restartHero();
          return;
        }
        const tab = event.target.closest('[data-pack]');
        if (tab && this.contains(tab)) {
          event.preventDefault();
          activate(tab.dataset.pack);
        }
        const thumb = event.target.closest('[data-image]');
        if (thumb && this.contains(thumb)) {
          event.preventDefault();
          const gallery = thumb.closest('.hmth-gallery');
          const img = gallery.querySelector('.hmth-featured');
          img.removeAttribute('srcset');
          img.src = thumb.dataset.image;
          img.alt = thumb.dataset.alt;
          gallery.querySelectorAll('[data-image]').forEach(el => el.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current','true');
        }
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-mobile-pack]')) activate(event.target.value);
        if (event.target.matches('select[name="id"]')) {
          const option = event.target.selectedOptions[0];
          if (option.dataset.price) event.target.closest('.hmth-panel').querySelector('[data-price]').textContent = option.dataset.price;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solids-trio-builder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.st').forEach((root)=>{const sizes=[...root.querySelectorAll('.st-size')],colours=[...root.querySelectorAll('.st-colour')],previews=[...root.querySelectorAll('.st__picked-card')],add=root.querySelector('.st__add'),counter=root.querySelector('.st__counter'),error=root.querySelector('.st__error'),sizeGuide=root.querySelector('.st__size-guide-dialog'),sizeGuideOpen=[...root.querySelectorAll('.st__size-guide-open')],sizeGuideClose=root.querySelector('.st__size-guide-close');let selected=[];let active=sizes.find(b=>b.classList.contains('is-on'));let size=active?.dataset.size||'',variant=active?.dataset.variant||'';const render=()=>{colours.forEach(b=>{const on=selected.some(i=>i.colour===b.dataset.colour);b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',String(on));b.disabled=selected.length===3&&!on});previews.forEach((card,index)=>{const item=selected[index];card.classList.toggle('is-empty',!item);card.querySelector('.st__crop').style.backgroundImage=item?`url("${item.image}")`:'';card.querySelector('strong').textContent=item?`${item.colour} · ${size}`:'Pick a colour'});counter.textContent=`${selected.length}/3`;add.disabled=selected.length!==3||!size;add.textContent=!size?'Choose your size to continue':selected.length!==3?`Pick ${3-selected.length} colour${3-selected.length===1?'':'s'} to continue`:'Add My Pack — ₹1,299 at Checkout';error.hidden=true};const resetPack=()=>{selected=[];size='';variant='';sizes.forEach(button=>{button.classList.remove('is-on');button.setAttribute('aria-checked','false')});add.classList.remove('is-loading');render()};const showImage=(url)=>{const main=root.querySelector('.st__main-image');if(!url||!main)return;main.style.opacity='.35';setTimeout(()=>{main.src=url;main.srcset='';main.style.opacity='1'},120);[...root.querySelectorAll('.st__thumb')].forEach(t=>t.classList.toggle('is-on',t.dataset.galleryImage===url))};[...root.querySelectorAll('.st__thumb')].forEach(t=>t.addEventListener('click',()=>showImage(t.dataset.galleryImage)));const hero=root.querySelector('.st__hero'),thumbs=[...root.querySelectorAll('.st__thumb')];const navigateImage=direction=>{if(thumbs.length<2)return;const current=Math.max(0,thumbs.findIndex(t=>t.classList.contains('is-on')));showImage(thumbs[(current+direction+thumbs.length)%thumbs.length].dataset.galleryImage)};root.querySelector('.st__nav--prev')?.addEventListener('click',()=>navigateImage(-1));root.querySelector('.st__nav--next')?.addEventListener('click',()=>navigateImage(1));let touchStart=null;if(hero){hero.addEventListener('touchstart',event=>{touchStart=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null},{passive:true});hero.addEventListener('touchend',event=>{if(!touchStart||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-touchStart.x,dy=event.changedTouches[0].clientY-touchStart.y;touchStart=null;if(Math.abs(dx)<45||Math.abs(dx)<=Math.abs(dy)||thumbs.length<2)return;const current=Math.max(0,thumbs.findIndex(t=>t.classList.contains('is-on'))),next=(current+(dx<0?1:-1)+thumbs.length)%thumbs.length;showImage(thumbs[next].dataset.galleryImage);thumbs[next].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'})},{passive:true});hero.addEventListener('touchcancel',()=>{touchStart=null},{passive:true})}sizes.forEach(b=>b.addEventListener('click',()=>{sizes.forEach(i=>{i.classList.remove('is-on');i.setAttribute('aria-checked','false')});b.classList.add('is-on');b.setAttribute('aria-checked','true');size=b.dataset.size;variant=b.dataset.variant;render()}));colours.forEach(b=>b.addEventListener('click',()=>{const index=selected.findIndex(i=>i.colour===b.dataset.colour);if(index>=0)selected.splice(index,1);else if(selected.length<3){selected.push({colour:b.dataset.colour,image:b.dataset.image});showImage(b.dataset.image)}render()}));if(sizeGuide&&sizeGuideOpen.length&&sizeGuideClose){sizeGuideOpen.forEach(button=>button.addEventListener('click',()=>sizeGuide.showModal()));sizeGuideClose.addEventListener('click',()=>sizeGuide.close());sizeGuide.addEventListener('click',event=>{if(event.target===sizeGuide)sizeGuide.close()})}add.addEventListener('click',async()=>{if(selected.length!==3||!variant||add.classList.contains('is-loading'))return;add.disabled=true;add.classList.add('is-loading');add.textContent='Adding your trio…';error.hidden=true;const properties={'Pack size':size,'Tee 1':selected[0].colour,'Tee 2':selected[1].colour,'Tee 3':selected[2].colour,'Free gift':'Chiller Shoe Bag'};try{const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,properties}]})});if(!response.ok)throw new Error('We could not add this pack. Please try again.');resetPack();window.location.href=`${window.Shopify.routes.root}cart`}catch(caught){error.textContent=caught.message;add.classList.remove('is-loading');render();error.hidden=false}});window.addEventListener('pageshow',event=>{if(!event.persisted)return;resetPack()});render()});

  } catch(e) { console.error(e); }
})();
})();
